var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8ec59cda6d839377eee81d87809796d29afe03a5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["policy-expert-site@qmetric"]={id:"8ec59cda6d839377eee81d87809796d29afe03a5"};
      